import React from 'react'

const Helper = ({ className, text }) => {
  if (!text) return <></>
  return <div className={`text-base text-primary-text mt-6 italic ${className}`}>{text}</div>
}

export default Helper
